import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { HideUpComponent } from '@df/ui/hide-up/hide-up.component';
import { ToggleModule } from '@df/ui/toggle/toggle.module';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsDataChangeService, NICmsDataChange } from '@icms/core/data/change/icms-data-change.service';
import { MultisiteSwitchComponent } from '../../../../multisite/multisite-switch.component';
import { AbstractPageFooterColumnComponent } from '../abstract-page-footer-column.component';
import { NPageFooter } from '../page-footer.interface';

@Component({
    selector: 'page-footer-column',
    templateUrl: './page-footer-column.component.html',
    standalone: true,
    imports: [HideUpComponent, HrefComponent, ICmsClientModule, MultisiteSwitchComponent, ToggleModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageFooterColumnComponent extends AbstractPageFooterColumnComponent implements OnInit {
    @Input({ required: true })
    override column!: NPageFooter.IPageFooterColumn;

    @Input()
    isFirst = false;

    @Input()
    isLast = false;

    @Input()
    index = 0;

    readonly toggleGroup = 'footer-column';

    protected iCmsDataChangeService = inject(ICmsDataChangeService);

    override ngOnInit() {
        super.ngOnInit();

        this.subscriptions.add(
            this.iCmsDataChangeService.afterChange$.subscribe(event => {
                if (event.changeType === NICmsDataChange.EChangeType.change || event.changeType === NICmsDataChange.EChangeType.delete) {
                    this.detectChanges();
                }
            })
        );
    }
}
